import React, { useState } from "react";

export const Features = (props) => {
  const [expanded, setExpanded] = useState({});
  const handleToggle = (idx) => {
    setExpanded((prev) => ({ ...prev, [idx]: !prev[idx] }));
  };
  return (
    <div id="features" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>What We Offer</h2>
        </div>
        <div className="row g-3">
          {props.data
            ? props.data.map((d, i) => {
                const lines = d.text.split('\n');
                const intro = lines.find((line) => !line.trim().startsWith('•'));
                const bullets = lines.filter((line) => line.trim().startsWith('•'));
                const showAll = expanded[i];
                const showToggle = bullets.length > 2;
                return (
                  <div key={`${d.title}-${i}`} className="col-12 col-sm-6 col-md-4 mb-4">
                    <div className="service-card" style={{
                      maxWidth: "400px",
                      width: "100%",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      background: "#fff",
                      borderRadius: "12px",
                      boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
                      padding: "18px 20px 16px 20px",
                      margin: "10px auto",
                      textAlign: 'center',
                      transition: 'box-shadow 0.3s',
                    }}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 18 }}>
                        <i className={d.icon} style={{ fontSize: 48, color: '#2563eb', marginBottom: 12 }}></i>
                        <h3 style={{ fontWeight: 700, fontSize: 22, margin: 0, textAlign: 'center' }}>{d.title}</h3>
                      </div>
                      <div style={{ marginBottom: 10, fontWeight: 500 }}>{intro}</div>
                      <ul style={{ textAlign: 'left', fontSize: 16, lineHeight: 1.7, paddingLeft: 18, margin: 0, width: '100%' }}>
                        {(showAll ? bullets : bullets.slice(0,2)).map((line, idx) => (
                          <li key={idx} style={{ marginBottom: 8 }}>{line.replace(/^•\s*/, '')}</li>
                        ))}
                      </ul>
                      {bullets.length > 0 && (
                        <button
                          onClick={() => handleToggle(i)}
                          style={{
                            background: 'none',
                            border: 'none',
                            color: '#2563eb',
                            fontWeight: 600,
                            cursor: 'pointer',
                            marginTop: 8,
                            outline: 'none',
                            fontSize: 15
                          }}
                          aria-label={showAll ? 'Show less' : 'Read more'}
                        >
                          {showAll ? 'Show less' : 'Read more'}
                        </button>
                      )}
                    </div>
                  </div>
                );
              })
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};
